<script>
import get from 'lodash/get';
import embedsMixin from '@shared/mixins/embeds';
import EmbedButton from '@school/components/EmbedButton.vue';

export default {
  mixins: [embedsMixin],
  components: { EmbedButton },
  data: () => ({
    buyable: get(window, 'initialState.membership', null)
      || get(window, 'initialState.training', null)
      || get(window, 'initialState.bundle', null),
  }),
};
</script>

<template>
  <div>
    <EmbedButton v-if="buyable" :params="$route.query" v-bind="{ buyable }" />
    <div v-else class="has-text-centered is-size-7 has-text-grey">
      Aucun prix actif trouvé pour cet abonnement.
    </div>
  </div>
</template>
